import { createFileRoute } from '@tanstack/react-router';
import { PalletBandsPage } from '../../../../features/admin/system-settings/pallet-bands/pallet-bands-page';

export const Route = createFileRoute('/admin/system-settings/pallet-bands/')({
  component: PalletBandsPage,
});
